import { CaseDetails } from './casedetails.model';
import { ManagedBy } from './managedby.model';
import { ProductGroup } from './productgroup.model';

export class CaseProperties {
    GuaranteeFundMutableTC?: any;
    CalculationCorrectionValue?: any;
    IsCalculationValueMutableTC: string;
    CaseDetails: CaseDetails = new CaseDetails();
    CaseID: number;
    ExternalSettlement?: any;
    Finished: boolean;
    ManagedBy: ManagedBy = new ManagedBy();
    ProductGroup: ProductGroup = new ProductGroup();

    public constructor(init?: Partial<CaseProperties>) {
        Object.assign(this, init);
    }
}
